var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcChallengesWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M12.0467553,16.9998471 L8.53328138,22.0176079 L6.8520812,17.4448234 L1.98006502,17.4289964 L5.44969044,12.4738578 C5.15905078,11.7046948 5,10.8709215 5,10 C5,6.13400675 8.13400675,3 12,3 C15.8659932,3 19,6.13400675 19,10 C19,10.8030073 18.8647875,11.574434 18.615888,12.2927548 L22.2123231,17.4289964 L17.340307,17.4448234 L15.6591068,22.0176079 L12.1447133,16.9985339 C12.1121149,16.999195 12.0794617,16.9996332 12.0467553,16.9998471 Z M12,14 C9.790861,14 8,12.209139 8,10 C8,7.790861 9.790861,6 12,6 C14.209139,6 16,7.790861 16,10 C16,12.209139 14.209139,14 12,14 Z M12,15 C14.7614237,15 17,12.7614237 17,10 C17,7.23857625 14.7614237,5 12,5 C9.23857625,5 7,7.23857625 7,10 C7,12.7614237 9.23857625,15 12,15 Z",
    transform: "translate(-2 -3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChallengesWhite);
export default __webpack_public_path__ + "static/media/ic-challenges-white.86269600e447d886c4a20c4fb418b37d.svg";
export { ForwardRef as ReactComponent };